export default __webpack_public_path__ + "static/media/card-brewery.7b4a0cdb.png";